import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import AuthShell from '../auth/AuthShell';
import Spinner from '../components/Spinner';
import api from '../api';

export default function LogoutPage() {
    const [state, setState] = useState('pending');
    const [attempt, setAttempt] = useState(0);
    const [error, setError] = useState(null);
    const operation = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        let active = true;
        // StrictMode повторно подписывается на тот же запрос: два POST подряд могли бы
        // удалить новую сессию, созданную между первым выходом и его повтором.
        if (!operation.current || operation.current.attempt !== attempt) {
            operation.current = {
                attempt,
                promise: api.get('/api/auth/logout-context').then(async ({ data: context }) => {
                    if (context.loginRequired || context.accountId == null) return context;
                    await api.get('/api/auth/csrf');
                    await api.post('/api/auth/logout', null, { params: { all: false, accountId: context.accountId } });
                    return context;
                }),
            };
        }
        operation.current.promise
            .then(context => {
                if (!active) return;
                if (context.loginRequired) navigate(context.loginUrl, { replace: true });
                else setState('done');
            })
            .catch(failure => {
                if (!active) return;
                setError(failure.response?.status === 409
                    ? 'Аккаунт изменился в другой вкладке. Повторите выход из нужного аккаунта.'
                    : 'Не удалось завершить выход. Проверьте подключение и попробуйте снова.');
                setState('error');
            });
        return () => { active = false; };
    }, [attempt, navigate]);

    const retry = () => { setState('pending'); setAttempt(value => value + 1); };

    if (state === 'pending') return <AuthShell title="Выход из аккаунта">
        <div role="status" className="flex items-center gap-3"><Spinner />Выходим на этом устройстве…</div>
    </AuthShell>;

    if (state === 'error') return <AuthShell title="Не удалось выйти">
        <p className="auth-error" role="alert">{error}</p>
        <button className="auth-primary w-full" onClick={retry}>Повторить</button>
    </AuthShell>;

    return <AuthShell title="Вы вышли на этом устройстве">
        <LogOut size={36} className="mb-5" aria-hidden="true" />
        <p className="auth-description">Сеанс аккаунта на этом устройстве завершён. Для повторного входа в него потребуется авторизация.</p>
        <Link to="/login" className="auth-primary flex items-center justify-center no-underline">Войти снова</Link>
    </AuthShell>;
}
